const encodeToURL = (text: string): string => encodeURIComponent(text);

export default { encodeToURL }